import request from '../../config/axiosConfig';
import { CREATE_VIDEO, DELETE_VIDEO, GET_LIST_VIDEOS, GET_VIDEO_INFO, UPDATE_VIDEO } from '../../constants/apiEndPoint';

export const getListVideosRequest = async (data) => {
  const result = await request({
    url: GET_LIST_VIDEOS,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getVideoInfoRequest = async (data) => {
  const result = await request({
    url: GET_VIDEO_INFO,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const createVideoRequest = async (data) => {
  const result = await request({
    url: CREATE_VIDEO,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const updateVideoRequest = async (data) => {
  const result = await request({
    url: UPDATE_VIDEO,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const deleteVideoRequest = async (data) => {
  const result = await request({
    url: DELETE_VIDEO,
    method: 'POST',
    data,
  });
  return result?.data;
};
